import { get } from '../api/axios';
import endpoints from '../api/endpoints';

const getCollaboratorUserId = collaborator => {
  const user = collaborator?.user || collaborator;
  const userId = user?.id || collaborator?.user_id;
  return userId != null ? String(userId) : '';
};

export const isDirectMessageWithUser = (
  collaborators = [],
  userId,
  currentUserId = '',
) => {
  const targetId = String(userId || '');
  if (!targetId) return false;

  const participantIds = collaborators
    .map(getCollaboratorUserId)
    .filter(Boolean);

  if (!participantIds.includes(targetId)) return false;
  if (collaborators.length > 2) return false;

  if (collaborators.length === 2) {
    const otherIds = participantIds.filter(
      id => id !== String(currentUserId || ''),
    );
    return otherIds.length === 1 && otherIds[0] === targetId;
  }

  return collaborators.length <= 1;
};

export const findConversationForUser = (
  conversations = [],
  userId,
  currentUserId = '',
) =>
  conversations.find(conversation => {
    if (conversation?.isGroup) return false;

    const participants = conversation?.participants || [];
    const participantIds = participants
      .map(person => (person?.id != null ? String(person.id) : ''))
      .filter(Boolean);

    if (!participantIds.includes(String(userId))) return false;

    const otherIds = participantIds.filter(
      id => id !== String(currentUserId || ''),
    );
    return otherIds.length === 1 && otherIds[0] === String(userId);
  }) || null;

export const findProjectMessageContextId = async (
  projectId,
  userId,
  currentUserId = '',
) => {
  if (!projectId || !userId) return null;

  let page = 1;
  let lastPage = 1;

  while (page <= lastPage) {
    const response = await get(endpoints.getMessageContexts, {
      params: {
        project_id: projectId,
        page,
        per_page: 50,
      },
      skipErrorToast: true,
    });

    if (!response?.data?.success) break;

    const result = response.data.result || {};
    lastPage = Number(result.last_page) || 1;
    const rows = Array.isArray(result.data) ? result.data : [];

    const match = rows.find(item =>
      isDirectMessageWithUser(
        Array.isArray(item?.collaborators) ? item.collaborators : [],
        userId,
        currentUserId,
      ),
    );

    if (match?.id) return match.id;
    page += 1;
  }

  return null;
};
